import {
	RECEIVE_BAD_REQUEST_BREACH_CAUSATION_CP, RECEIVE_BREACH_CAUSATION_CP,
	REQUEST_BREACH_CAUSATION_CP
} from "./index";


export function requestBreachCausationCp(token){
	return {
		type: REQUEST_BREACH_CAUSATION_CP,
		payload: token
	}
}

export function receiveBreachCausationCp(lawSysAgents){
	return {
		type: RECEIVE_BREACH_CAUSATION_CP,
		payload: lawSysAgents
	}
}
export function receiveBadRequestBreachCausationCp(lawSysAgents){
	return {
		type: RECEIVE_BAD_REQUEST_BREACH_CAUSATION_CP,
		payload: lawSysAgents
	}
}
